import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import { KTSVG, toAbsoluteUrl } from '../../helpers'
import { useLayout } from '../../layout/core'
import SideMenuList from './SideMenuList'
import UserContext from '../../context/UserContext'
import { usePlan } from '../../context/PlanContext'
import RolePermissionContext from '../../context/RolePermissionContext'
import { useQuery } from '@apollo/client'
import { GET_WHITE_LABELING_BY_ID } from '../../graphql/query'

const SideMenu: React.FC = () => {
  const { config, classes, setLayout } = useLayout()
  const { aside } = config
  const { currentUserRole } = useContext(UserContext)
  const { currentPlan } = usePlan()
  const { data2 } = useContext(RolePermissionContext)
  // const { loading, error, data } = useQuery(GET_USER_BY_ID)
  const [toNavigate, setToNavigate] = useState<any>('')
  const navigate = useNavigate()
  const { data, loading, error } = useQuery(GET_WHITE_LABELING_BY_ID, {
    variables: {
      input: {
        bgAccountId: currentPlan?.bgAccountId
      }
    }
  })

  useEffect(() => {
    if (data2) {
      const sideMenuListWithAccess = getSideMenuList(data2)
      setToNavigate(sideMenuListWithAccess?.to)
    }
  }, [data2])

  function getSideMenuList(jsonData: any) {
    if (jsonData && jsonData.getModuleAcessByRole && jsonData.getModuleAcessByRole.data) {
      const permissions = jsonData.getModuleAcessByRole.data

      for (const permission of permissions) {
        if (permission.isAccess && Object.keys(permission.module.sideMenu).length > 0) {
          return permission.module.sideMenu
        }
      }
    }

    return null
  }

  // Toggle Side Menu Panel
  const toggleSideMenu = () => {
    if (aside.minimized) {
      document.getElementById('kt_aside_toggle')?.classList.add('active')
    } else {
      document.getElementById('kt_aside_toggle')?.classList.remove('active')
      document.getElementById('kt_aside')?.classList.remove('aside-hoverable')
      setTimeout(() => document.getElementById('kt_aside')?.classList.add('aside-hoverable'), 100)
    }
    const newConfig = Object.assign({}, config)
    newConfig.aside.minimized = !newConfig.aside.minimized
    setLayout(newConfig)
  }
  const navigateToSubscription = () => {
    navigate('/subscription')
  }

  if (loading) {
    return <p>Loading...</p>
  }

  if (error) {
    return <p>Error while loading</p>
  }

  return (
    <div id='kt_aside' className={clsx('aside sidebar-wrapper', classes.aside.join(' '))}>
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto h-100px' id='kt_aside_logo'>
        {/* begin::Logo */}
        <Link to={toNavigate}>
          <img
            alt='Botgo Logo'
            className='h-100px py-5 logo'
            src={
              data?.getWhiteLabelingbyId[0]?.logo ||
              toAbsoluteUrl('/media/logos/botgo-logo-2nd.png')
            }
          />
        </Link>
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            onClick={toggleSideMenu}
          >
            <KTSVG
              path={`/media/icons/duotune/arrows/arr080.svg`}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* Side menu with scrollbar for y-axis */}
      <div
        className='hover-scroll-overlay-y'
        style={{ maxHeight: 'calc(100% - 200px)', overflowY: 'auto', overflowX: 'hidden' }}
      >
        <SideMenuList asideMenuClasses={classes.aside} />
      </div>

      {/* Footer fixed at the bottom */}
      <div className='aside-footer' style={{ position: 'absolute', bottom: 0, width: '100%' }}>
        <div className='d-flex flex-column flex-center py-7'>
          {!currentUserRole.admin ? (
            <a className='btn btn-custom btn-primary w-100' href='/logout' title='Sign out'>
              <span className='btn-label'>Sign Out</span>
              <span className='svg-icon btn-icon svg-icon-2'>
                <KTSVG path='/media/icons/duotune/general/gen042.svg' />
              </span>
            </a>
          ) : (
            <span
              className='btn btn-custom btn-primary w-100'
              title={currentPlan?.package?.package?.packageName.replace(/_/g, ' ')}
              onClick={navigateToSubscription}
            >
              <span className='btn-label'>
                {' '}
                {currentPlan?.package?.package?.packageName.replace(/_/g, ' ')}
              </span>
              <span className='svg-icon btn-icon svg-icon-2'>
                <KTSVG path='/media/icons/duotune/communication/com011.svg' />
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default SideMenu
